import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pay-success-page" }
const _hoisted_2 = {
  class: "pay-success-shell",
  "aria-labelledby": "pay-success-title"
}
const _hoisted_3 = { class: "success-hero" }
const _hoisted_4 = {
  class: "success-icon",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  class: "order-card",
  "aria-label": "订单信息"
}
const _hoisted_6 = { class: "amount-block" }
const _hoisted_7 = { class: "amount-value" }
const _hoisted_8 = { class: "order-list" }
const _hoisted_9 = { class: "order-row" }
const _hoisted_10 = { class: "order-row" }
const _hoisted_11 = { class: "payment-method" }
const _hoisted_12 = { class: "order-row" }

import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getRegistrationCode } from '@/api/pay'


export default /*@__PURE__*/_defineComponent({
  __name: 'payment-success',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const registrationCode = ref('')

const methodMap = {
  wechat: {
    name: '微信支付',
    icon: ['fab', 'weixin'],
    className: 'wechat'
  },
  alipay: {
    name: '支付宝',
    icon: ['fab', 'alipay'],
    className: 'alipay'
  }
} as const

const getQueryText = (key: string, fallback: string) => {
  const value = route.query[key]

  if (Array.isArray(value)) {
    return value[0] || fallback
  }

  return value || fallback
}

const displayAmount = computed(() => {
  const rawAmount = getQueryText('total_amount', getQueryText('amount', '0.00'))
  const amount = Number(rawAmount)

  if (!Number.isFinite(amount)) {
    return rawAmount
  }

  return amount.toFixed(2)
})

const orderNo = computed(() =>
  getQueryText('orderNo', getQueryText('out_trade_no', getQueryText('orderId', '')))
)

const payTime = computed(() => getQueryText('timestamp', getQueryText('payTime', '')))

const paymentMethod = computed(() => {
  const method = getQueryText('paymentMethod', getQueryText('method', 'alipay')).toLowerCase()
  if (method.includes('alipay')) return methodMap.alipay
  if (method.includes('wechat')) return methodMap.wechat
  return method in methodMap ? methodMap[method as keyof typeof methodMap] : methodMap.alipay
})

const paymentMethodName = computed(() => paymentMethod.value.name)
const paymentMethodIcon = computed(() => paymentMethod.value.icon)
const paymentMethodClass = computed(() => `payment-method-icon-${paymentMethod.value.className}`)

const handleReg = () => {
  router.push({
    path: '/activate/'+registrationCode.value
  })
}

onMounted(() => {
  getRegistrationCode(orderNo.value).then(res=>{
    registrationCode.value = res
  }).catch(err=>{
    
  })
})

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"confetti-layer\" aria-hidden=\"true\" data-v-6c7d1d1a><span class=\"confetti confetti-1\" data-v-6c7d1d1a></span><span class=\"confetti confetti-2\" data-v-6c7d1d1a></span><span class=\"confetti confetti-3\" data-v-6c7d1d1a></span><span class=\"confetti confetti-4\" data-v-6c7d1d1a></span><span class=\"confetti confetti-5\" data-v-6c7d1d1a></span><span class=\"confetti confetti-6\" data-v-6c7d1d1a></span></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, { icon: "check" })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("h1", {
          id: "pay-success-title",
          class: "success-title"
        }, "支付成功", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "success-desc" }, "感谢您的支付，祝您生活愉快！", -1))
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "amount-label" }, "支付金额", -1)),
          _createElementVNode("strong", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("small", null, "¥", -1)),
            _createTextVNode(" " + _toDisplayString(displayAmount.value), 1)
          ])
        ]),
        _createElementVNode("dl", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[5] || (_cache[5] = _createElementVNode("dt", null, "订单编号", -1)),
            _createElementVNode("dd", null, _toDisplayString(orderNo.value), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("dt", null, "支付方式", -1)),
            _createElementVNode("dd", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(["payment-method-icon", paymentMethodClass.value]),
                "aria-hidden": "true"
              }, [
                _createVNode(_component_font_awesome_icon, { icon: paymentMethodIcon.value }, null, 8, ["icon"])
              ], 2),
              _createTextVNode(" " + _toDisplayString(paymentMethodName.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[7] || (_cache[7] = _createElementVNode("dt", null, "支付时间", -1)),
            _createElementVNode("dd", null, _toDisplayString(payTime.value), 1)
          ])
        ])
      ]),
      _createElementVNode("section", {
        class: "action-group",
        "aria-label": "页面操作"
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "secondary-action",
          onClick: handleReg
        }, " 立即注册 ")
      ])
    ])
  ]))
}
}

})